import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router';

import { ClubSelection } from '@screens';
import { isCurrentActivityAtom } from '@store';

import { LINKS } from '../utils/routes';

export const ClubSelectionScreen = () => {
    const navigate = useNavigate();
    const isCurrentActivity = useAtomValue(isCurrentActivityAtom);
    return (
        <ClubSelection
            isCurrentActivity={isCurrentActivity}
            getActivityLink={LINKS.getActivity}
            onClose={() => navigate(LINKS.getFullActivity())}
        />
    );
};
